














import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import path from 'path';
import urlJoin from 'url-join';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { S3_BASE_FILE_DIR } from '~/constants/contents';
import { DynamicPartsPdfButton } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppRectButton,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsPdfButton>,
      required: true,
    },
  },
  setup(props) {
    /** PDFダウンロード用のURL */
    const pdfDownloadUrl = computed(() => {
      // CMS側のドメインをフロントに合わせるため、proxy用のURLを生成
      return urlJoin(S3_BASE_FILE_DIR, path.basename(props.item.pdf.fileUrl));
    });
    const openPdf = () => {
      window.open(pdfDownloadUrl.value, '_blank');
    };
    return { openPdf };
  },
});
